/**
 * How far the DOM believes it is rotated from the device's natural
 * orientation, in degrees clockwise: 0 portrait, 90 the phone's top
 * edge toward the user's left, 180 reverse portrait, 270 the other
 * landscape.
 *
 * Read as its own signal rather than inferred from `innerWidth >
 * innerHeight`, because the two answer different questions: the aspect
 * comparison says what shape the layout is, this says which way the
 * layout has been turned. Correcting a pointer delta needs the latter.
 *
 * Falls back to 0 when the runtime does not report an angle, which is
 * also what an unrotated screen reports.
 */
export function readDomAngle(): number {
  const angle = (
    screen as unknown as { orientation?: { angle?: number } }
  ).orientation?.angle
  return typeof angle === 'number' ? angle : 0
}
